import { useEffect, useState } from "react";
import { Loader2, Building2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

const TINT = {
  active: "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  trial: "bg-sky-50 text-sky-700 dark:bg-ink-gold/10 dark:text-ink-gold",
  suspended: "bg-amber-50 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300",
  deactivated: "bg-rose-50 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300",
};

export default function CustomerOrganizations() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/platform/tenants").then((r) => setRows(r.data)).catch((e) => toast.error(apiError(e))).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-indigo-600 dark:text-ink-gold" /></div>;

  return (
    <div className="space-y-6" data-testid="customer-orgs-page">
      <div>
        <p className="text-xs font-medium uppercase tracking-wider text-indigo-400 dark:text-ink-gold">Platform Management</p>
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 dark:text-ink-text">Customer Organizations</h1>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">Subscription and account status only — never customer travel operations.</p>
      </div>
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm dark:border-ink-line dark:bg-ink-card">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="customer-orgs-table">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500 dark:border-ink-line dark:bg-ink/40">
                <th className="px-5 py-3 font-medium">Customer Organization</th>
                <th className="px-5 py-3 font-medium">Plan</th>
                <th className="px-5 py-3 font-medium">Status</th>
                <th className="px-5 py-3 font-medium">Billing</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((t) => (
                <tr key={t.company_id} className="border-b border-slate-100 last:border-0 dark:border-ink-line" data-testid={`customer-org-${t.company_id}`}>
                  <td className="px-5 py-3">
                    <div className="flex items-center gap-2 font-medium text-slate-800 dark:text-ink-text"><Building2 className="h-4 w-4 text-slate-400" />{t.brand_name}</div>
                    <div className="pl-6 text-xs text-slate-400">{t.legal_name}</div>
                  </td>
                  <td className="px-5 py-3 text-slate-600 dark:text-slate-300">{t.subscription?.plan_id || "—"}</td>
                  <td className="px-5 py-3"><span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${TINT[t.subscription?.status] || "bg-slate-100 text-slate-500"}`}>{t.subscription?.status || "—"}</span></td>
                  <td className="px-5 py-3 font-mono-tf text-xs text-slate-500">{t.subscription ? `${t.subscription.billing_amount} ${t.subscription.billing_currency}/${t.subscription.billing_interval}` : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
